import script from "./TopicSkeleton.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopicSkeleton.vue?vue&type=script&setup=true&lang=ts"

import "./TopicSkeleton.vue?vue&type=style&index=0&id=552b5968&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-552b5968"]])

export default __exports__